import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import Responsive from "../../components/Responsive";
import SidebarView from '../SidebarView';
import StagesManager from '../StagesManager';
import ProfitLoss from './reports/ProfitLoss';


export default class Reports extends Component {
    state = {
        type: [
            { icon: '/assets/images/stopwatch.svg', title: 'Business Overview', children: [{ options: '{{lang}}Profit and Loss', typePage: 'profitloss' }, { options: 'Cash Flow Statement' }, { options: '{{lang}}Balance Sheet' }, { options: 'Business Performance Ratios' }, { options: 'Business Performance Ratios' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Sales', children: [{ options: 'Sales by Customer' }, { options: 'Sales by Item' }, { options: 'Sales by Person' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Inventory', children: [{ options: 'Inventory Summary' }, { options: 'Inventory Valuation Summary' }, { options: 'FIFO Cost Lot Tracking' }, { options: 'Product Sales Report' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Receivables', children: [{ options: 'Customer Balances' }, { options: 'Aging Summary' }, { options: 'Aging Details' }, { options: 'Invoice Details' }, { options: 'Retainer Invoice Details' }, { options: 'Sales Order Details' }, { options: 'Delivery Challan Details' }, { options: 'Estimate Details' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Payments Received', children: [{ options: 'Payments Received' }, { options: 'Time to Get Paid' }, { options: 'Credit Note Details' }, { options: 'Refund History' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Recurring Invoices', children: [{ options: 'Recurring Invoice Details' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Payables', children: [{ options: 'Vendor Balances' }, { options: 'Aging Summary' }, { options: 'Aging Details' }, { options: 'Bills Details' }, { options: 'Vendor Credits Details' }, { options: 'Payments Made' }, { options: 'Refund History' }, { options: 'Purchase Order Details' }, { options: 'Purchase Orders by Vendor' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Taxes', children: [{ options: 'Tax Summary' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Purchases and Expenses', children: [{ options: 'Purchases by Vendor' }, { options: 'Purchases by Item' }, { options: 'Expense Details' }, { options: 'Expense by Category' }, { options: 'Expenses by Customer' }, { options: 'Expenses by Project' }, { options: 'Expenses by Employee' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Projects and Timesheet', children: [{ options: 'Project Summary' }, { options: 'Project Details' }, { options: 'Timesheet Details' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Accountant', children: [{ options: 'Project Summary' }, { options: 'Account Transactions' }, { options: 'Account Type Summary' }, { options: 'General Ledger' }, { options: 'Detailed General Ledger' }, { options: 'Journals Report' }, { options: 'Trial Balance' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Budgets', children: [{ options: 'Budget Vs Actuals' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Currency', children: [{ options: 'Realized Gain or Loss' }, { options: 'Unrealized Gain or Loss' }] },
            { icon: '/assets/images/stopwatch.svg', title: 'Activity', children: [{ options: 'System Mails' }, { options: 'Activity Logs' }, { options: 'Exception Report' }, { options: 'Portal Activities' }, { options: 'Client Reviews' }, { options: 'API Usage' }] },
        ]


    }

    handleTypePage = (key, value) => {
        // this.setState({ [key]: value })
        // console.log('key', key, 'value', value)
        this.sidebarView.openSidebar()
    }

    render() {
        let type = this.state.type
        return (
            <div className='w-100 d-flex flex-wrap'>
                <Responsive width={this.props.width} display={'flex'}>
                    <div className='d-flex flex-column py-4 w-100' style={{ backgroundColor: "#fff" }}>
                        <div className='flexcb w-100 pb-2' style={{ borderBottom: "1px solid #C3C3C3" }}>
                            <p className='font-size-16'>Reports</p>
                            <div>
                                <input className='px-3 py-2 br-5' style={{ border: "none", backgroundColor: "#E6E6E6" }} placeholder='Search Reports'></input>
                            </div>
                            <div className='flexcc'>
                                <button className='br-5 flexcc p-1 mx-2 br-5'>
                                    <img width={20} src='/assets/images/gear.svg' />
                                    <p style={{ color: "#0085FF" }}>Configure Report Layout</p>
                                </button>
                                <button className='br-5 flexcc py-2 prd-3 pld-2 mx-2' style={{ backgroundColor: "#DBEBF9" }}>
                                    <img width={20} src='/assets/images/stopwatch.svg' />
                                    <p style={{ color: "#0085FF" }}>Scheduled Reports</p>
                                </button>
                            </div>
                        </div>
                        <div className='pb-3 d-flex flex-wrap w-100'>
                            {type.map((item, index) => {
                                return (


                                    <Responsive width={this.props.width} display={'flex'} media={{ xs: '12', sm: '6', md: '4' }}>
                                        <div className="d-flex w-100 px-5">
                                            <div className="d-flex br-10 w-100">
                                                <div className="" style={{ minWidth: "50%" }}>
                                                    <div className="d-flex flex-column">
                                                        <div className="flexc pt-5">
                                                            <p className="font-size-18 weight-300">{item.title}</p>
                                                        </div>
                                                        {item.children.map((child, i) => {
                                                            return (
                                                                <button onClick={() => this.handleTypePage('page', child.options)}>

                                                                    <div className="flexc" style={{ borderBottom: "1px dashed #C3C3C3" }}>
                                                                        <p className="font-size-14 weight-300 py-2" style={{ color: "#002FC9" }}>{child.options}</p>
                                                                    </div>
                                                                </button>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Responsive>

                                );
                            })}
                        </div>
                    </div>

                </Responsive>

            </div>
        )
    }
}

